<template>
  <div class="app-view">
    <Sidebar />
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import StorageService from "@/services/storage.service";
import { useGeneralStore } from "@/store/general.store";
import { useAuthStore } from "@/store/auth.store";

export default {
  name: "AppView",
  components: {
    Sidebar,
  },

  async beforeRouteEnter(to, from, next) {
    const generalStore = useGeneralStore();
    const authStore = useAuthStore();

    // Fetch user profile
    await authStore.getUserProfile();

    // Fetch organizations
    const organizations = await generalStore.getOrganizations();

    async function handleOrganizations() {
      if (to.params.organizationId === undefined) {
        const savedId = StorageService.getOrganization();
        if (savedId != null) {
          // Read from cookie
          try {
            const organization = await generalStore.getOrganization(savedId);
            await generalStore.setOrganization(organization.value);
            to.params.organizationId = organization.value.id;

            // Fetch data
            await generalStore.getData();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            StorageService.removeOrganization();
            return handleOrganizations();
          }
        } else {
          if (organizations.value.length) {
            // Select first organization
            await generalStore.setOrganization(organizations.value[0]);
            to.params.organizationId = organizations.value[0].id;

            // Fetch data
            await generalStore.getData();
          } else {
            // No organizations
            return next({ name: "no-organizations" });
          }
        }
      } else {
        // Fetch organization
        const organization = await generalStore.getOrganization(to.params.organizationId);
        await generalStore.setOrganization(organization.value);

        // Fetch data
        await generalStore.getData();
      }
      next();
    }

    return handleOrganizations();
  },
};
</script>

<style lang="scss" scoped>
.app-view {
  display: flex;
  height: 100%;
  // height: -moz-available;
  // height: -webkit-fill-available;
  // height: fill-available;
  background: var(--background-color);

  .main {
    flex-grow: 1;
    overflow: auto;
  }
}
</style>
